(function (angular, ToyotaForms) {
    'use strict';

    angular
        .module('Toyota.Directives')
        .directive('formsContactUs', ['$filter', 'API', function ($filter, API) {
            formsContactUsController.$inject = ['$scope', 'AddressById'];
            function formsContactUsController($scope, AddressById) {
                $scope.init = function () {

                    $scope.fields = {
                        firstname: '',
                        lastname: '',
                        phone: '',
                        email: '',
                        postcodeMainForm: '',
                        carSelectionOne: '',
                        carSelectionOwnToyota: '',
                        ownAToyota: 'false',
                        yearSelected: '',
                        enquiryType: '',
                        enquirySubType: '',
                        enquiryTypeAnalyticsLabel: '',
                        message: '',
                        formName: '',
                        campaignCode: '',
                        address: '',
                        registrationMainForm: '',
                        registration: '',
                        addressId: '',
                        toyotaCustomerFleet: '',
                        toyotaCustomerFinance: '',
                        customerNumber: '',
                        assistPreferenceFinance: '',
                        assistPreferenceInsurance: '',
                        insurancePolicyType: '',
                        contactPreference: '',
                        employerOrEmployee: '',
                        positionTitle: '',
                        industry: '',
                        haveNovatedLease: '',
                        hearAboutUs: '',
                        fleetCompanyName: '',
                        novatedCompanyName: '',
                        companyContact: '',
                        numberOfEmployees: ''
                    };


                    $scope.form = {
                        submitting: false,
                        completed: false,
                        success: false
                    };

                    $scope.vehicleModelList = ['carSelectionOne'];

                    $scope.showMOI = false;
                    $scope.showRego = false;
                    $scope.showAddress = false;
                    $scope.showFinanceSec = false;
                    $scope.showInsuranceSec = false;
                    $scope.showOwnAToyotaSec = true;
                    $scope.showInsurancePolicyType = false;
                    $scope.showFleetSec = false;
                    $scope.showRoadsideAssistanceSec = false;

                    $scope.$on('address-tag-added', function (event, data) {

                        $scope.fields.addressId = data.data.info.search_result_id;

                        var addressTask = AddressById(data.data.info.search_result_id);

                        addressTask.then(function (data) {
                            $scope.fields.address = data;
                        });
                    });

                    $scope.$on('address-tag-removed', function () {
                        $scope.fields.address = "";
                    });

                    $scope.$watch('fields.enquiryType', function (value) {
                        $scope.$evalAsync(function () {
                            $scope.fields.enquiryTypeAnalyticsLabel = $scope.getEnquiryTypeAnalyticsLabel(value);
                        });

                        var valueLowerCase = value.toLowerCase();

                        $scope.showMOI = false;
                        $scope.showRego = false;
                        $scope.showAddress = false;
                        $scope.showFinanceSec = false;
                        $scope.showInsuranceSec = false;
                        $scope.showInsurancePolicyType = false;
                        $scope.showOwnAToyotaSec = true;
                        $scope.showFleetSec = false;
                        $scope.showRoadsideAssistanceSec = false;

                        switch (true) {
                            case valueLowerCase.indexOf('brochure') > -1:
                                $scope.showMOI = true;
                                $scope.showAddress = true;
                                break;
                            case valueLowerCase.indexOf('finance') > -1:
                                $scope.showRego = true;
                                $scope.showFinanceSec = true;
                                $scope.showOwnAToyotaSec = false;
                                break;
                            case valueLowerCase.indexOf('insurance') > -1:
                                $scope.showInsuranceSec = true;
                                if ($scope.fields.assistPreferenceInsurance.toLowerCase().indexOf('comprehensive') > -1) {
                                    $scope.showRego = true;
                                    $scope.showInsurancePolicyType = true;
                                }
                                else {
                                    $scope.showRego = false;
                                    $scope.showInsurancePolicyType = false;
                                }
                                $scope.showOwnAToyotaSec = false;
                                break;
                            case valueLowerCase.indexOf('novated') > -1:
                                $scope.showOwnAToyotaSec = false;
                                break;
                            case valueLowerCase.indexOf('vehicle') > -1:
                                $scope.showMOI = true;
                                break;
                            case valueLowerCase.indexOf('fleet') > -1:
                                $scope.showFleetSec = true;
                                break;
                            case valueLowerCase.indexOf('roadside') > -1:
                                $scope.showRego = true;
                                $scope.showRoadsideAssistanceSec = true;
                                $scope.showOwnAToyotaSec = false;
                                break;
                        }
                    });

                    $scope.$watch('fields.assistPreferenceInsurance', function (newValue, oldValue) {
                        if (newValue === oldValue) {
                            return;
                        }

                        if (newValue.toLowerCase().indexOf('comprehensive') > -1) {
                            $scope.showRego = true;
                            $scope.showInsurancePolicyType = true;
                        }
                        else {
                            $scope.showRego = false;
                            $scope.showInsurancePolicyType = false;
                        }
                    });
                };

                $scope.init();

                $scope.getEnquiryTypeAnalyticsLabel = function (selectedEnquiryType) {
                    if ($scope.isSelectedEnquiryTypeNovatedB2B(selectedEnquiryType)) {
                        return selectedEnquiryType + ' - ' + $scope.fields.enquirySubType.toUpperCase();
                    }
                    return selectedEnquiryType;
                };

                $scope.isSelectedEnquiryTypeNovatedB2B = function (selectedEnquiryType) {
                    return selectedEnquiryType && selectedEnquiryType.toLowerCase().indexOf('novated') > -1 && $scope.fields.enquirySubType === 'b2b';
                };

                $scope.isNovatedB2B = function () {
                    return $scope.fields.enquiryType.toLowerCase().indexOf('novated') > -1 && $scope.fields.enquirySubType === 'b2b';
                };

                $scope.isNovatedB2C = function () {
                    return $scope.fields.enquiryType.toLowerCase().indexOf('novated') > -1 && $scope.fields.enquirySubType !== 'b2b';
                };

                $scope.vehicleInvalid = function (fieldId, isRequired) {
                    // only validate while the user is filling the form
                    if (fieldId === $scope.vehicleModelList[0]) {
                        if (($scope.fields.enquiryType.toLowerCase().indexOf('brochure') > -1 || $scope.fields.enquiryType.toLowerCase().indexOf('vehicle') > -1)
                            && $scope.fields[fieldId] === '' && ($scope.wfm[fieldId].$touched || $scope.wfm.$submitted)) {
                            return true;
                        }
                        return false;
                    }

                    if (!isRequired) {
                        return false;
                    }

                    if (!$scope.wfm[fieldId].$touched && !$scope.wfm.$submitted) {
                        return false;
                    }

                    return !$scope.wfm[fieldId].$valid;
                };

                $scope.vehicleValid = function (fieldId, isRequired) {

                    if (fieldId === $scope.vehicleModelList[0]) {
                        if (($scope.fields.enquiryType.toLowerCase().indexOf('brochure') > -1 || $scope.fields.enquiryType.toLowerCase().indexOf('vehicle') > -1)
                            && $scope.fields[fieldId] !== '' && $scope.wfm[fieldId].$touched) {
                            return true;
                        }
                        return false;
                    }

                    if (!isRequired) {
                        return false;
                    }

                    // only validate while the user is filling the form
                    if (!$scope.wfm[fieldId].$touched) {
                        return false;
                    }

                    return $scope.wfm[fieldId].$valid;
                };

                $scope.addressInValid = function () {
                    return $scope.fields.addressId === "" && ($scope.wfm.address && $scope.wfm.address.$touched || $scope.wfm.$submitted);
                };

                $scope.addressValid = function () {
                    return $scope.fields.addressId !== "" && $scope.wfm.address && $scope.wfm.address.$touched;
                };

                $scope.isExistingFinanceCustomer = function () {
                    return $scope.fields.enquiryType.toLowerCase().indexOf('finance') > -1
                        && $scope.wfm.toyotaCustomerFinance && $scope.wfm.toyotaCustomerFinance.$modelValue
                        && $scope.wfm.toyotaCustomerFinance.$modelValue.toLowerCase().indexOf('existing') > -1;
                };

                $scope.isFinanceCustomerTypeRequired = function () {
                    return $scope.fields.enquiryType.toLowerCase().indexOf('finance') > -1;
                };

                $scope.isFleetCustomerTypeRequired = function () {
                    return $scope.fields.enquiryType.toLowerCase().indexOf('fleet') > -1;
                };

                $scope.isPostcodeRequired = function () {
                    return $scope.fields.enquiryType.toLowerCase().indexOf('finance') > -1
                        || $scope.fields.enquiryType.toLowerCase().indexOf('insurance') > -1
                        || $scope.fields.enquiryType.toLowerCase().indexOf('fleet') > -1
                        || $scope.isNovatedB2C();
                };

                $scope.isContactPreferenceRequired = function () {
                    return $scope.fields.enquiryType.toLowerCase().indexOf('finance') > -1
                        || $scope.fields.enquiryType.toLowerCase().indexOf('insurance') > -1
                        || $scope.fields.enquiryType.toLowerCase().indexOf('fleet') > -1
                        || $scope.fields.enquiryType.toLowerCase().indexOf('roadside') > -1
                        || $scope.isNovatedB2C();
                };

                $scope.isAssistPreferenceRequired = function (fieldId, isRequired) {
                    if (isRequired && $scope.fields.enquiryType.toLowerCase().indexOf('finance') > -1 && fieldId.toLowerCase().indexOf('finance') > -1) {
                        return true;
                    }
                    else if (isRequired && $scope.fields.enquiryType.toLowerCase().indexOf('insurance') > -1 && fieldId.toLowerCase().indexOf('insurance') > -1) {
                        return true;
                    }

                    return false;
                };

                $scope.isInsurancePolicyTypeRequired = function (isRequired) {
                    if ($scope.fields.enquiryType.toLowerCase().indexOf('insurance') > -1 && $scope.showInsurancePolicyType) {
                        return true;
                    }

                    return isRequired;
                };

                $scope.isRegistrationRequired = function (fieldId, isRequired) {
                    if (fieldId !== 'registration') {
                        return $scope.isExistingFinanceCustomer();
                    }

                    return isRequired;
                };

                $scope.isStateRequired = function (isRequired) {
                    return isRequired;
                };

                $scope.isEmployerOrEmployeeRequired = function () {
                    return $scope.isNovatedB2C();
                };

                $scope.isNovatedLeaseCheckRequired = function () {
                    return $scope.isNovatedB2C();
                };

                $scope.isCompanyNameRequired = function () {
                    return $scope.isNovatedB2B();
                };

                $scope.isCompanyContactRequired = function () {
                    return $scope.isNovatedB2B();
                };

                $scope.isNumberOfEmployeesRequired = function () {
                    return $scope.isNovatedB2B();
                };

                $scope.selectFieldOption = function (listId, fieldId, selected) {
                    if (selected && $scope[listId]) {
                        selected = selected.toLowerCase();

                        $scope[listId].forEach(function (currentValue) {
                            if (currentValue.Text.toLowerCase() === selected) {
                                $scope.fields[fieldId] = currentValue.Text;
                            }
                        });
                    }
                };

                $scope.getData = function () {
                    var agreement;
                    if ($('#terms-checkbox').length) {
                        agreement = $scope.fields.agreement;
                    }
                    else {
                        agreement = true;
                    }

                    var contactUsData = {
                        EnquiryType: $scope.fields.enquiryType,
                        Message: $scope.fields.message,
                        FirstName: $scope.fields.firstname,
                        LastName: $scope.fields.lastname,
                        Email: $scope.fields.email,
                        Phone: $scope.fields.phone,
                        OwnAToyota: $scope.fields.ownAToyota,
                        Agreement: agreement,
                        FormName: $scope.fields.formName,
                        CampaignCode: $scope.fields.campaignCode
                    };

                    if ($scope.fields.ownAToyota === "true") {
                        _.extend(contactUsData, {
                            CarSelectionOwnToyota: $scope.fields.carSelectionOwnToyota,
                            Year: $scope.fields.yearSelected,
                            Registration: $scope.fields.registration
                        });
                    }

                    if ($scope.fields.enquiryType.toLowerCase().indexOf('brochure') > -1) {
                        _.extend(contactUsData, {
                            CarSelectionOne: $scope.fields.carSelectionOne
                        });

                        if (typeof $scope.fields.address !== 'undefined') {
                            _.extend(contactUsData, {
                                Address: {
                                    street: $scope.fields.address.street_address,
                                    suburb: $scope.fields.address.suburb,
                                    postcode: $scope.fields.address.postcode,
                                    state: $scope.fields.address.state
                                }
                            });
                        }
                    }

                    if ($scope.fields.enquiryType.toLowerCase().indexOf('finance') > -1) {
                        _.extend(contactUsData, {
                            PostcodeMainForm: $scope.fields.postcodeMainForm,
                            AssistPreference: $scope.fields.assistPreferenceFinance,
                            ToyotaCustomer: $scope.fields.toyotaCustomerFinance,
                            RegistrationMainForm: $scope.fields.registrationMainForm,
                            ContactPreference: $scope.fields.contactPreference
                        });

                        if (typeof $scope.fields.customerNumber !== 'undefined') {
                            _.extend(contactUsData, {
                                CustomerNumber: $scope.fields.customerNumber
                            });
                        }
                    }

                    if ($scope.fields.enquiryType.toLowerCase().indexOf('insurance') > -1) {
                        _.extend(contactUsData, {
                            PostcodeMainForm: $scope.fields.postcodeMainForm,
                            AssistPreference: $scope.fields.assistPreferenceInsurance,
                            RegistrationMainForm: $scope.fields.registrationMainForm,
                            ContactPreference: $scope.fields.contactPreference
                        });

                        if ($scope.showInsurancePolicyType === true) {
                            _.extend(contactUsData, {
                                InsurancePolicyType: $scope.fields.insurancePolicyType
                            });
                        }
                    }

                    if ($scope.isNovatedB2C()) {
                        _.extend(contactUsData, {
                            EnquirySubType: $scope.fields.enquirySubType || 'B2C',
                            PostcodeMainForm: $scope.fields.postcodeMainForm,
                            ContactPreference: $scope.fields.contactPreference,
                            EmployerOrEmployee: $scope.fields.employerOrEmployee,
                            PositionTitle: $scope.fields.positionTitle,
                            Industry: $scope.fields.industry,
                            HaveNovatedLease: $scope.fields.haveNovatedLease,
                            HearAboutUs: $scope.fields.hearAboutUs
                        });
                    }

                    if ($scope.isNovatedB2B()) {
                        _.extend(contactUsData, {
                            EnquirySubType: $scope.fields.enquirySubType,
                            CompanyName: $scope.fields.novatedCompanyName,
                            CompanyContact: $scope.fields.companyContact,
                            NumberOfEmployees: $scope.fields.numberOfEmployees
                        });
                    }

                    if ($scope.fields.enquiryType.toLowerCase().indexOf('vehicle') > -1) {
                        _.extend(contactUsData, {
                            CarSelectionOne: $scope.fields.carSelectionOne
                        });
                    }

                    if ($scope.fields.enquiryType.toLowerCase().indexOf('fleet') > -1) {
                        _.extend(contactUsData, {
                            ToyotaCustomer: $scope.fields.toyotaCustomerFleet,
                            PostcodeMainForm: $scope.fields.postcodeMainForm,
                            CompanyName: $scope.fields.fleetCompanyName,
                            ContactPreference: $scope.fields.contactPreference,
                        });
                    }

                    if ($scope.fields.enquiryType.toLowerCase().indexOf('roadside') > -1) {
                        _.extend(contactUsData, {
                            RegistrationMainForm: $scope.fields.registrationMainForm,
                            ContactPreference: $scope.fields.contactPreference,
                        });
                    }

                    return contactUsData;
                };

                $scope.submit = function () {

                    if (($scope.fields.enquiryType.toLowerCase().indexOf('brochure') > -1 || $scope.fields.enquiryType.toLowerCase().indexOf('vehicle') > -1) && $scope.fields.carSelectionOne === '' ||
                        $scope.fields.enquiryType.toLowerCase().indexOf('brochure') > -1 && ($scope.fields.addressId === '' || typeof $scope.fields.address === 'undefined')) {
                        return;
                    }

                    $scope.form.submitting = true;

                    var url = $filter('formatArgs')(ToyotaForms.API.FormSubmission.ContactUs);
                    var data = $scope.getData();

                    API.post(url, data)
                        .then(function (req) {
                            $scope.form.submitting = false;
                            $scope.form.completed = true;
                            if (req.data.isSuccessful) {
                                $scope.form.success = true;
                            } else {
                                $scope.form.success = false;
                            }

                            if ($scope.form.completed && $scope.form.success) {
                                $scope.$broadcast('form-success');
                            } else {
                                $scope.$broadcast('form-failure');
                            }
                        }, function () {
                            $scope.form.success = false;
                            $scope.$broadcast('form-server-error');
                        });
                };
            }

            return {
                scope: true,
                restrict: 'A',
                controller: formsContactUsController,
                controllerAs: 'fc',
                bindToController: true,
                link: function (scope, element, attrs) {

                }
            };
        }]);
})(window.angular, window.ToyotaForms);
